// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  dataCompilacao: '00/00/0000 00:00:00',
  commitSha: 'AAAAAAAAAAAAAAAAAAAAAAAA',
  versao: '1.0.0',
  duracaoTokenEmMinutos: 60 * 12,
  paths: {
    base: 'http://localhost:8090/rest',
    permiteAlterarBackend: true,
  },
  keycloak: {
    issuer: 'https://sso.stg.cloud.pje.jus.br/auth',
    realm: 'pje',
    clientId: 'codex-frontend',
  },
};
